<template>
  <div class="box">
    <div class="row">
      <div class="column medium-12">
        <div class="label">{{ $t('common.username') }}</div>
        <input type="text" name="username" v-model="username"
          autocomplete="off" :disabled="loading"
          @keypress.enter="login">
      </div>
    </div>

    <div class="row">
      <div class="column medium-12">
        <div class="label">{{ $t('common.password') }}</div>
        <input type="password" v-model="password" autocomplete="off"
          :disabled="loading" @keypress.enter="login">
      </div>
    </div>

    <div class="row log-in-btn">
      <div class="column medium-12">
        <transition name="slide-down">
          <span class="error-message" v-show="!!errorMessage">{{ errorMessage }}</span>
        </transition>
        <a :class="['op-btn btn-lg btn-success btn-block', {'disabled':loading}]" @click="login">
          <span v-if="loading">
            <i class="fas fa-spinner fa-spin fa-fw"></i>{{ $t('common.loading') }}
          </span>
          <span v-else>{{ $t('common.login') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import uuidv4 from 'uuid/v4'
import { isValidNumber } from 'libphonenumber-js'
import ApiPickupType from '@/modules/api/pickup-type'

export default {
  name: 'login-form',
  data () {
    return {
      username: '',
      password: '',
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    login () {
      let self = this
      let token = 'CORP-' + uuidv4()
      if (self.loading) { return }

      self.loading = true
      self.errorMessage = ''
      self.$sdk.post(self, '/auth/login/corporate', {
        username: self.username,
        password: self.password,
        token: token
      }, res => {
        self.loading = false

        if (!res.error) {
          self.$root.$emit('setSession', token)
          self.$store.commit('user/setToken', token)
          self.$store.commit('user/setUserInfo', {
            ID: res.id,
            email: res.contactEmail,
            firstName: res.name,
            lastName: '',
            phone: {
              number: res.contactPhone,
              code: res.countryCode || ''
            },
            bday: res.dateOfBirth,
            country: res.userCountry,
            passportNum: res.passportNum
          })

          self.$store.commit('user/setIsCorporate', true)
          self.$store.commit('user/setCorporateData', {
            name: res.name,
            logo: res.logoUrl
          })

          if (res.discountCode) {
            self.loading = true
            self.$root.$emit('redeemCode', {code: res.discountCode})
            return
          }

          self.$emit('loginSuccess')
        } else {
          self.errorMessage = res.error.message
        }
      })
    },
    pickupTypeUpdate (userInfo) {
      let self = this

      let userPhone = '+' + userInfo.countryCode + userInfo.phone
      let notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      ApiPickupType.update(self, {isUS: notInternational}, function (data) {
        if (data.action === 'mobileCCUpdate') {
          let rsvp = self.$store.state.reservation
          if (rsvp.leg1.isAirportPickup) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg1.pickupType,
              fee: rsvp.leg1.pickupFee
            })
          }
          if (rsvp.isRoundtrip && rsvp.leg2.pickupHasAirline) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg2.pickupType,
              fee: rsvp.leg2.pickupFee
            })
          }
        }
      })
    }
  },
  mounted () {
    let self = this
    self.$root.$on('redeemCodeSuccess', function (res) {
      self.loading = false
      self.$emit('loginSuccess')
    })

    self.$root.$on('invalidPromoCode', function () {
      self.loading = false
      self.$emit('loginSuccess')
    })
  }
}
</script>

<style lang="scss" scoped>
.box{
  padding: 20px;

  .column{
    padding: 0 5px;
    margin-bottom: 10px;
  }
  .label {
    font-size: 13px;
    text-align: left;
  }
  input{
    margin: 0;
    color: #333;
    line-height: inherit;
    -webkit-transition: all .15s ease;
    transition: all .15s ease;
    width: 100%;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 40.4px;
    border-radius: 0;
    width: 100%;
    border: none;
    border: 1px solid #ccc;
    padding: 10px;
    background: #fbfbfb;
    color: #444;
    outline: none;
    -webkit-box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-transition: all .3s linear;
    transition: all .3s linear;
  }
  .error-message{
    background: #EB5837;
    font-size: 12px;
    padding: 3px 10px 5px;
    color: #fff;
    display: block;
    text-align: center;
    margin-bottom: 10px;
    border-radius: 2px;
  }
}

.log-in-btn {
  margin: 0 auto;
  margin-top: 15px;
}

.fa-spinner{ margin-right: 5px; }

.slide-down-small-enter-active, .slide-down-small-leave-active { transition: all .3s ease; }
.slide-down-small-enter, .slide-down-small-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// LoginForm.vue?4f6fe060